import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { gallery } from "../data/content";

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <>
      <PageHeader title="Gallery" crumbs={[{ label: "Gallery" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Our Gallery"
            title="A Glimpse of Our <span>Fleet & Service</span>"
          />
          <div className="gallery-grid">
            {gallery.map((src, i) => (
              <div className="gallery-item" key={i} onClick={() => setActive(src)}>
                <img src={src} alt={`Gallery ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="lightbox" onClick={() => setActive(null)}>
          <button className="close" aria-label="Close"><FaTimes /></button>
          <img src={active} alt="Preview" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
}
